/** Small formatters for console metadata. Epoch ms throughout (docs/CONTRACT.md §2). */

export function initialsFor(name: string): string {
  const parts = name.trim().split(/\s+/).slice(0, 2)
  if (parts.length === 0 || parts[0] === '') return '?'
  return parts.map((part) => part[0]?.toUpperCase() ?? '').join('')
}

export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) return '—'
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']
  let value = bytes
  let unit = 0
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024
    unit += 1
  }
  const digits = value >= 100 || unit === 0 ? 0 : 1
  return `${value.toFixed(digits)} ${units[unit]}`
}

/** `online`, `last seen 5 min ago`, … — the same wording apps/web uses for presence. */
export function formatPresence(online: boolean, lastSeenAt: number | null): string {
  if (online) return 'online'
  if (!lastSeenAt) return 'never seen'
  const seconds = Math.max(0, Math.round((Date.now() - lastSeenAt) / 1000))
  if (seconds < 60) return 'last seen just now'
  const minutes = Math.round(seconds / 60)
  if (minutes < 60) return `last seen ${minutes} min ago`
  const hours = Math.round(minutes / 60)
  if (hours < 24) return `last seen ${hours} h ago`
  return `last seen ${new Date(lastSeenAt).toLocaleDateString()}`
}

/** `10 Oct 2026, 14:03` — absolute, for rows that carry a timestamp. */
export function formatStamp(at: number | null): string {
  if (at === null) return '—'
  return new Date(at).toLocaleString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
